import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false
}

export const interviewTabRefreshSlice = createSlice({
    name: 'interview/interviewTabRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh } = interviewTabRefreshSlice.actions;
export default interviewTabRefreshSlice.reducer